module.exports = __webpack_public_path__ + "static/img/0010-test.070950b0.jpg";